<template>
  <div class="sm-admin-mail-list">
    <single-controller
      v-if="tab == 'single'"
      @summary="$emit('summary', $event)"
    />
    <group-controller
      v-else-if="tab == 'group'" 
    />
  </div>
</template>
<script>
import SingleMailController from '@/views/admin/pages/mail/components/SingleMailController';
import GroupMailController from '@/views/admin/pages/mail/components/GroupMailController';

export default {
  name: 'mail-list',
  components: {
    'single-controller': SingleMailController,
    'group-controller': GroupMailController,
  },
  data() {
    return {

    }
  },
  created() {
    
  },
  computed: {
    tab() {
      return this.$route.query.tab || 'single';
    },
  },
}
</script>

<style lang="scss">
  .sm-admin-mail-list {
    padding-bottom: 80px;

    & .sm-pager {
      margin-top: 20px;
    }
  }
</style>